import React from "react";
import { DEFAULT_WAREHOUSE_STATE } from "../reducers";

const WarehouseContext = React.createContext({
  // warehouse: {
  //   tenantInfo: [],
  //   webhooks: [],
  //   environment: {},
  //   webhookStatus: {
  //     loading: false,
  //     error: "",
  //   },
  //   userCurrentStep: 1,
  //   isComplianceFormFilled: false,
  //   environmentBaseURL: "https://api.sandbox.getphyllo.com",
  //   environmentChanged: false,
  // },
  warehouse: DEFAULT_WAREHOUSE_STATE,
  dispatchWarehouse: () => {},
});

export const WarehouseContextProvider = WarehouseContext.Provider;
export default WarehouseContext;
